import styled from "styled-components";
export const Navigation = styled.nav`
  padding: 3px 10px !important;
  position: sticky !important;
  top: 0 !important;
  z-index: 1000 !important;
`;
export const Button = styled.button``;
export const More = styled.div``;
export const Nav = styled.ul`
  position: relative;
  margin-left: auto;
`;
export const NavItems = styled.li``;
